import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';   
import { StorageService } from './storage.service';
@Injectable({
providedIn: 'root'
})
export class UserService {

	utoken:string;
	uinfo:any; 
	uemail:string;
	userAddresses:any = [];
	addressRecieved:boolean;

	onUserTokenChanged$: BehaviorSubject<string>;
	onUserInfoChanged$: BehaviorSubject<any>;
	onTabChanged$: BehaviorSubject<string>;  
	onUserAddressesChanged$: BehaviorSubject<any[]>;  
	
	private baseUrl = environment.apiUrl;
	readonly userTypeConst = {shopper:1, shop:2, company:3, individual:4, boss:786} 
	
	constructor(private http:HttpClient, private storage:StorageService) 
	{    
		this.onUserTokenChanged$ = new BehaviorSubject("");
		this.onUserInfoChanged$ = new BehaviorSubject({});
		this.onTabChanged$ = new BehaviorSubject(null);  
		this.onUserAddressesChanged$ = new BehaviorSubject(null);  
		this.init();
	}

	init()
	{  
		this.utoken = this.storage.getItem("cul_culture_tm_stmp_temp"); 
		this.onUserTokenChanged$.next(this.utoken);  
		var uin = this.storage.getItem("cul_locale_tm_stmp_temp"); 

		if(uin)
		{
			try
			{
				this.uinfo = JSON.parse(uin); 
				this.onUserInfoChanged$.next(this.uinfo);
			}
			catch{} 
		}  
		else
		{
			this.uinfo = {};
			this.onUserInfoChanged$.next(this.uinfo);
		} 
	}

	getSetUserAddress(): Observable<any[]> {
		if (this.isLoggedIn()) {
			return this.getUserAddress().pipe(
				take(1),
				tap(res => {
					this.userAddresses = res || [];
					this.onUserAddressesChanged$.next(this.userAddresses);
				})
			);
		} else { 
			return of([]);
		}
	}

	setToken(token:string)
	{
		this.utoken = token;
		this.onUserTokenChanged$.next(this.utoken); 
        this.storage.setItem("cul_culture_tm_stmp_temp", this.utoken); 
	}

	setTokenGetInfo(token:string, email:string)
	{
		this.utoken = token;
		this.onUserTokenChanged$.next(this.utoken); 
        this.storage.setItem("cul_culture_tm_stmp_temp", this.utoken); 

		this.getAndInitUserInfo(email).subscribe(
		{
			complete:()=>
			{

			}
		});
	}

	getAndInitUserInfo(email:string): Observable<any> 
	{
		return this.getUserIfoByEmail(email).pipe(map((res:any) => 
        {
			if(res)
			{
				this.uinfo = res;
				this.onUserInfoChanged$.next(this.uinfo);
				this.storage.setItem("cul_locale_tm_stmp_temp", JSON.stringify(this.uinfo));
			}
        }));
	}   

	/// Having a session means holding a token AND knowing who the user is.
	///
	/// This used to test `uinfo.SID > 0`. SID is the SELLER id: it is assigned when a
	/// shop is registered and stays 0 for an ordinary shopper, because Register never
	/// sets it. So the check was really asking "are you a seller?", and every shopper
	/// account was treated as logged out - login succeeded, the token and profile were
	/// stored, the page reloaded, and the header still showed the login form.
	///
	/// Sellers are unaffected: they have an Id and Email too.
	isLoggedIn():boolean
	{
		return !!(this.utoken && this.uinfo && (this.uinfo.Id || this.uinfo.Email));
	}

	/// Same correction as isLoggedIn. Gating on SID meant a shopper got 0 rather than
	/// their real AccountType (shopper = 1), so comparisons against userTypeConst
	/// silently took the wrong branch for exactly the users they were meant to match.
	userType():number
	{
		if(this.uinfo && (this.uinfo.Id || this.uinfo.Email))
		{
			return this.uinfo.AccountType;
		}

		return 0;
	}

	/// The signed-in account's seller id (its shop's id), or 0 for a shopper or nobody.
	sellerId():number
	{
		return this.isLoggedIn() && this.uinfo.SID > 0 ? Number(this.uinfo.SID) : 0;
	}

	isNijera():boolean
	{
		if(this.uinfo !== null && this.uinfo !== undefined && this.uinfo.SID > 0)
		{
			if(this.uinfo.AccountType === 786)
			{
				return true;
			}
		}

		return false;
	}

	isNijerShop():boolean
	{
		if(this.uinfo !== null && this.uinfo !== undefined && this.uinfo.SID > 0)
		{ 
			if(this.uinfo.UserRoles !== null && this.uinfo.UserRoles !== undefined && this.uinfo.UserRoles.includes('nijershop'))
			{
				return true;
			}
		}

		return false;
	}

	onLogout()
	{
		this.storage.clearLocal()
		this.init();  
	} 

	newBDGuid() :string
	{
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
			var r = Math.random() * 16 | 0,
			v = c == 'x' ? r : (r & 0x3 | 0x8);
			return v.toString(16);
		});
	}

	private getUserIfoByEmail(email:string): Observable<any> 
	{  
		const params: {[param: string]: string} = {ue: email};  

		return this.http.get<any>(this.baseUrl +`/api/Account/getmurgioutofanda/`, {params}); 
	} 

	updateUserInfo(model:any): Observable<any> 
	{
		return this.http.post<any>(this.baseUrl +`/api/UserProfile/UpdateUserInfo/`, model);
	}

	getUserAddress(): Observable<any> 
	{
		return this.http.get<any>(this.baseUrl +`/api/UserProfile/GetAddress/`, {});
	}
	getAddressById(id:number): Observable<any> 
	{
		return this.http.get<any>(this.baseUrl +`/api/UserProfile/GetAddressById/${id}`, {});
	}

	addUserAddress(model:any): Observable<any> 
	{
		return this.http.post<any>(this.baseUrl +`/api/UserProfile/AddNewAddress`, model);
	}

	updateUserAddress(model:any): Observable<any> 
	{
		return this.http.post<any>(this.baseUrl +`/api/UserProfile/UpdateAddress`, model);
	} 

	getSrc(st:string): Observable<any> 
	{
		return this.http.get<any>(this.baseUrl +`/api/Publisher/GetSourceUrl/${st}`);
	} 
}
